import { Response as ResponseType } from "../../types";
import { Response } from "./Response";
import HorizontalNavigation from "../HorizontalNavigation/HorizontalNavigation";

type ResponsesProps = {
  responses: ResponseType[];
  candidate: string;
};

// The single responses, one page each. The summary has its own tab.
const Responses = ({ responses, candidate }: ResponsesProps) => (
  <HorizontalNavigation pages={responses.map((response) => <Response key={response.responder} candidate={candidate} {...response} />)} />
);

export default Responses;
